module.exports = __webpack_public_path__ + "static/img/vrroad_function01.c239ea9e.png";